var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("标签审核")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c("form-filed", {
            ref: "formAttr",
            staticClass: "search-form",
            attrs: {
              formconfig: _vm.searchFormConfig.formconfig,
              formData: _vm.searchFormConfig.formData,
            },
            on: { formDataval: _vm.dialogClick },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("列表数据")]),
          _c("div", { staticClass: "but-list" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary", size: "small", plain: "" } },
                  [_vm._v("全部")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary", size: "small", plain: "" } },
                  [_vm._v("待备货（10）")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary", size: "small", plain: "" } },
                  [_vm._v("已备货（10）")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary", size: "small", plain: "" } },
                  [_vm._v("待发货（10）")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary", size: "small", plain: "" } },
                  [_vm._v("已发货")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary", size: "small", plain: "" } },
                  [_vm._v("售后件")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("el-button", { attrs: { type: "primary", size: "small" } }, [
                  _vm._v("导出记录"),
                ]),
                _c("el-button", { attrs: { type: "primary", size: "small" } }, [
                  _vm._v("导出发货"),
                ]),
              ],
              1
            ),
          ]),
          _c("lb-table", {
            attrs: {
              column: _vm.columns,
              data: _vm.list,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }